import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Landingpage from "./pages/Landingpage";
import Footer from "./components/Footer";
import ProjectManagement from "./pages/ProjectManagement";
import ScrollToTop from "./components/ScrollToTop";
import DigitalTransform from "./pages/DigitalTransform";
import TypeSettingKPO from "./pages/TypeSettingKPO";
import ContentConversion from "./pages/ContentConversion";
import Ebook from "./pages/Ebook";
import XMLTransformation from "./pages/XMLTransformation";
import FlashtoHtml from "./pages/FlashtoHtml";
import Aboutus from "./pages/Aboutus";
import News from "./pages/News";
import Newsdetail from "./pages/Newsdetail";
import Contactus from "./pages/Contactus";
import Allproducts from "./pages/Allproducts";
import Vedas from "./pages/Vedas";
import XpertXpress from "./pages/XpertXpress";
import Xpertproof from "./pages/Xpertproof";
import EditLatex from "./pages/EditLatex";
import Xpertreview from "./pages/Xpertreview";
import Sample from "./pages/Sample";
import Sampleimg from "./components/Sample/Sampleimg";
// import FAQ from "./pages/FAQ";
import Career from "./pages/Career";
import Journal from "./pages/Journal";
// import PeerReviewServices from "./pages/Content/PeerReviewServices";
// import Projectmanagement from "./pages/Content/Projectmanagement";
// import Accessibility from "./pages/Content/Accessibility";
// import EditorialServices from "./pages/Content/EditorialServices";
// import ProductionServices from "./pages/Content/ProductionServices";
import EditorialServicesbook from "./pages/Book/EditorialServicesbook";
import ProductionServicesbook from "./pages/Book/ProductionServicesbook";
import ProjectManagementbook from "./pages/Book/ProjectManagementbook";
import Accessibilitybook from "./pages/Book/Accessibilitybook";
import Careerdetail from "./pages/Careerdetail";
import { useEffect, useState } from "react";
import Agiletesting from "./pages/Agiletesting";
import AllContent from "./pages/Content/AllContent";
import Technology from "./pages/Technology";
import Xperttrack from "./pages/Xperttrack";
import HeaderLinkPage from "./pages/HeaderLinkPage";
import Disclaimer from "./pages/Disclaimer";
import ScrollTopButton from "./components/ScrollTopButton";
import { Toaster } from "react-hot-toast";
import AppLoader from "./components/Apploader";
import BannerModal from "./components/BannerModal/BannerModal";
import NotFound from "./pages/NotFound";
import Frankfurt2026 from "./components/landingpage/FrankFruit2026";

function App() {
  const [open, setIsOpen] = useState();
  const [showBanner, setShowBanner] = useState();
  const [bannerValid, setBannerValid] = useState(false);
  const location = useLocation();
  const isFrankfurtPage = location.pathname === "/frankfurt2026";

  useEffect(() => {
    const fromDate = new Date("2026-05-21T00:00:00");
    const targetDate = new Date("2026-10-15T00:00:00");

    const checkDate = () => {
      const now = new Date();
      console.log(fromDate);

      const isValid = now >= fromDate && now < targetDate;

      setBannerValid(isValid);
    };

    console.log(bannerValid);

    // Run immediately
    checkDate();

    // Check every minute
    const interval = setInterval(checkDate, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <AppLoader>
        <div className="relative min-h-[100vh] flex flex-col">
          {/* {bannerValid === true && (
            <BannerModal
              showBanner={showBanner}
              setShowBanner={setShowBanner}
            />
          )} */}
          {!isFrankfurtPage && (
            <div
              role="navigation"
              className="sticky top-[2.6%] md:top-[22px] z-[149] relative md:h-[91px] min-[1100px]:h-[107px]  h-[74px]"
            >
              <Header setprops={setIsOpen} />
            </div>
          )}
          <ScrollToTop />
          <Toaster />

          <div role="main" className={`h-full ${open ? "background" : ""}`}>
            <Routes>
              <Route
                path={"/"}
                element={
                  <Landingpage
                    bannerValid={bannerValid}
                    showBanner={showBanner}
                    setShowBanner={setShowBanner}
                  />
                }
              />
              <Route path={"/frankfurt2026"} element={<Frankfurt2026 />} />
              <Route path={"/all/:category"} element={<HeaderLinkPage />} />
              <Route
                path={"/projectmanagement"}
                element={<ProjectManagement />}
              />
              {/* <Route path={"/digitaltransform"} element={<DigitalTransform />}>
            <Route path={"contentconversion"} element={<ContentConversion />} />
            <Route path={"ebook"} element={<Ebook />} />
            <Route path={"xmltransformation"} element={<XMLTransformation />} />
            <Route path={"flashtohtml5"} element={<FlashtoHtml />} />
          </Route> */}
              <Route path={"/typesettingkpo"} element={<TypeSettingKPO />} />
              <Route path={"/company/Aboutus"} element={<Aboutus />} />
              <Route path={"/company/News"} element={<News />} />
              <Route
                path={"/company/Newsdetail/:id"}
                element={<Newsdetail />}
              />
              <Route path={"/company/contactus"} element={<Contactus />} />
              <Route path={"/products"} element={<Allproducts />}>
                <Route path={"vedas"} element={<Vedas />} />
                <Route path={"xpertxpress"} element={<XpertXpress />} />
                <Route path={"xpertproof"} element={<Xpertproof />} />
                <Route path={"editlatex"} element={<EditLatex />} />
                <Route path={"xpertreview"} element={<Xpertreview />} />
                <Route path={"xperttrack"} element={<Xperttrack />} />
                <Route path={"scholarlyxpert"} element={<Xpertreview />} />
              </Route>
              <Route path={"/company/sample"} element={<Sample />}>
                <Route path=":category" element={<Sampleimg />} />
              </Route>
              <Route path={"/Content"} element={<Journal />}>
                <Route path=":services" element={<AllContent />} />
              </Route>
              <Route path={"/digital"} element={<Journal />}>
                <Route path=":services" element={<AllContent />} />
              </Route>
              {/* <Route path={"/book"} element={<Journal />}>
            <Route
              path="ProjectManagement"
              element={<ProjectManagementbook />}
            />
            <Route path="accessibility" element={<Accessibilitybook />} />
            <Route
              path="editorialservices"
              element={<EditorialServicesbook />}
            />
            <Route
              path="productionservices"
              element={<ProductionServicesbook />}
            />
          </Route> */}
              {/* <Route path={"/company/FAQ"} element={<FAQ />} /> */}
              <Route path={"/company/career"} element={<Career />} />
              <Route path="/company/career/:job" element={<Careerdetail />} />
              {/* <Route path="/:testing" element={<Agiletesting />} /> */}
              <Route path="/technology" element={<Technology />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          {/* <div className=" bottom-[2.6%] md:bottom-[22px] z-[149] w-fit fixed right-[40px]"> */}
          <ScrollTopButton />

          {/* </div> */}
          {/* <div className="relative z-[147] mt-auto">
            <Footer />
          </div> */}
        </div>
      </AppLoader>
    </>
  );
}

export default App;
